<script setup lang="ts">
import { Toaster as Sonner } from 'vue-sonner'

const title = ref('Supercharge your revenue and customer growth')
const description = ref(
  'Bunce is a Data-driven customer engagement platform that enables retention and revenue growth for businesses.',
)

useHead({
  title,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  titleTemplate: (title: any) =>
    title !== title.value
      ? `${
          title > 50
            ? `${title.slice(0, 50)}...${title.endsWith('"') ? '"' : ''}`
            : title
        } · Bunce`
      : title,
})

useSeoMeta({
  title,
  ogTitle: title,
  ogType: 'website',
  description: () => description.value,
  ogDescription: description.value,
  ogImage: 'https://www.bunce.so/images/og-image.png',
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt:
    'Bunce: build lasting customer relationships, drive real business results',
  twitterCard: 'summary_large_image',
  twitterSite: '@trybunce',
  twitterImage: 'https://www.bunce.so/images/og-image.png',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
})
</script>

<template>
  <Sonner
    theme="light"
    class="toaster group"
    position="top-right"
    :class-names="{
      toast:
        'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
      description: 'group-[.toast]:text-muted-foreground',
      actionButton:
        'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
      cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
    }"
    :duration="4000"
    rich-colors
    :close-button="true"
  />

  <NuxtLayout>
    <NuxtLoadingIndicator
      color="repeating-linear-gradient(to right,#E7F0FE 0%, #3143B5 100%)"
    />
    <NuxtPage />
  </NuxtLayout>
</template>
